/**
 * <s-filmstrip> — a vertical strip of photos that slides from one photo to the next.
 * Clones the photos in its [data-track] once so the loop is seamless; the clones
 * are hidden from assistive tech. CSS owns the motion (direction, speed, pause on hover).
 * Shoppers who prefer reduced motion see the first photo standing still.
 */
class SFilmstrip extends HTMLElement {
  connectedCallback() {
    if (this.hasAttribute('data-ready')) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const track = this.querySelector('[data-track]');
    if (!track || track.children.length < 2) return;

    Array.from(track.children).forEach((frame) => {
      const clone = frame.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('inert', '');
      clone.querySelectorAll('img').forEach((img) => {
        img.removeAttribute('fetchpriority');
        img.setAttribute('loading', 'lazy');
      });
      track.append(clone);
    });
    this.setAttribute('data-ready', '');
  }
}

if (!customElements.get('s-filmstrip')) {
  customElements.define('s-filmstrip', SFilmstrip);
}
